
export enum FLEET_CARD_DASHBOARD_ROUTE_PATHS {
  FLEET_CARDS = '/fleet-cards',
  OVERVIEW = '/fleet-cards/overview',
  BENEFITS = '/fleet-cards/benefits',
  UPSELL_BENEFITS = '/fleet-cards/upsell/benefits',
  UPSELL_APPLY = '/fleet-cards/upsell/apply',
}